export default {
    id:"id",
    rating:"rate",
    content:"content",
    createdAt:"created_at"
}